import React from 'react'
import whatsapp from "../assets/whatsapp.png"

function WhatsAppbtn() {


  return (
 
    
            <a href="https://api.whatsapp.com/send/?phone=9041421329&text&type=phone_number&app_absent=0"><img src={whatsapp} alt="" width={50} /></a> 
  
  )
}

export default WhatsAppbtn